module.exports = __webpack_public_path__ + "img/theme1.29da0d53.png";